import React, { useContext, useEffect, useState } from 'react';
import { ContentChart } from '@meteor/frontend-core';
import { AppContext } from '../../../../contexts/AppContext';
import { GLOBAL_EVENT } from '../../../../consts/common/global-event';
import APIList from '../../../../http/ApiList';
import { cloneDeep } from 'lodash';
import ErrorBoundary from '../../../common/error-boundary';

const CustomizeMultipleScatterChart: React.FC<any> = (props) => {
  const { authInfo, echartTheme, globalEvent, setGlobalEvent } = useContext(AppContext);
  const { property } = props;
  const [chartLoading, setChartLoading] = useState<any>(false);
  const [chartData, setChartData] = useState<any>(null);
  const defaultChartOptions: any = {
    grid: {
      bottom: 110,
      top: 35,
      right: 20,
      left: 40,
    },
    legend: {
      type: 'scroll',
      data: [],
      right: 0,
      top: 0,
      width: '80%',
    },
    xAxis: {
      type: 'value',
      name: 'xName',
      nameLocation: 'center',
      scale: true,
      nameGap: 25,
    },
    yAxis: {
      type: 'value',
      name: 'yName',
      scale: true,
    },
    tooltip: {
      appendToBody: true,
      className: 'overflow-all',
      hideDelay: 0,
      formatter: function (params) {},
    },
  };
  const [options, setOptions] = useState<any>(defaultChartOptions);
  const oneHundredMillion = 100000000;

  const scatterSeries = (data) => {
    let dataSeries: any[] = [];
    data.forEach((d, i) => {
      let seriesItem = {
        type: 'scatter',
        emphasis: {
          focus: 'self',
        },
        datasetId: i,
      };
      dataSeries.push(seriesItem);
    });
    return dataSeries;
  };

  const getScatterData = (data) => {
    let dataSetArray: any[] = [];
    data.forEach((d, i) => {
      dataSetArray.push({ id: i, source: d });
    });
    return dataSetArray;
  };

  const getChartData = (event: string) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        setChartData(res.data);
        setChartLoading(false);
      });
  };

  useEffect(() => {
    if (!property || !property.chartOptions || !property.chartOptions.options) {
      return;
    }
    try {
      let op;
      if (property.chartOptions.options) {
        const reviver = (key, value) => {
          const arrowFunctionRegex = /^\s*\(?\s*([^)]*)\s*\)?\s*=>\s*{[^]*}$/;
          if (typeof value === 'string' && (value.startsWith('function') || arrowFunctionRegex.test(value))) {
            return new Function('return ' + value)();
          }
          return value;
        };
        const tempOp = JSON.parse(property.chartOptions.options, reviver);
        op = {
          ...options,
          ...tempOp,
        };
      } else {
        op = defaultChartOptions;
      }
      setOptions(cloneDeep({ ...op, echartTheme }));
    } catch (error) {}
  }, [property]);

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (
      (property.dataSource &&
        property.dataSource.triggerEvent &&
        property.dataSource.triggerEvent.find((triggerEvent) => {
          return triggerEvent.event === globalEvent.eventType;
        })) ||
      globalEvent.eventType === GLOBAL_EVENT.PAGE_INIT
    ) {
      setChartLoading(true);
      setTimeout(() => {
        getChartData(globalEvent);
      }, 500);
    }
  }, [globalEvent]);

  useEffect(() => {
    if (!chartData || chartData.length === 0) {
      return;
    }
    options.series = scatterSeries(chartData);
    options.dataset = getScatterData(chartData);
    setOptions(cloneDeep({ ...options, echartTheme }));
  }, [chartData]);

  return (
    <ErrorBoundary>
      <ContentChart
        title={{
          value: (
            <>
              <span>{property.title}</span> <span style={{ float: 'right' }}>{property.subtitle}</span>
            </>
          ),
          styles: {},
        }}
        contentList={[]}
        chartOptions={options}
        showSeriesLabel={false}
        mouseWheelZoomLock={false}
        loading={chartLoading}
        height={'90%'}
        tooltips={['zoomIn']}
        isBank={!chartData || chartData.length === 0}
        onChartEvent={setGlobalEvent}
      />
    </ErrorBoundary>
  );
};

export default CustomizeMultipleScatterChart;
